// Container Trader: the customer commission is presented to buyers as the credit card fee.
import { LINE_ITEM_CUSTOMER_COMMISSION } from './types';

export const CT_SUPPORT_EMAIL = 'admin@thecontainertrader.com';
export const CT_SUPPORT_PHONE_DISPLAY = '1-844-321-2876';
export const CT_SUPPORT_PHONE_TEL = '+18443212876';

const toNumber = p => {
  if (p == null) return null;
  const raw = typeof p === 'object' ? p.value ?? p.toString?.() : p;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

// Returns e.g. "4" or "3.5" (no trailing zeros), or null when unknown.
export const getCardFeePercent = lineItems => {
  const item = (lineItems || []).find(
    li => li.code === LINE_ITEM_CUSTOMER_COMMISSION && !li.reversal
  );
  const n = toNumber(item?.percentage);
  return n == null ? null : `${Math.round(n * 100) / 100}`;
};
